import React from 'react';
import Select from 'react-select';

const DropdownFormGroup = ({label, isRequired, name, id, value, onChange, options, isMulti = false}) => {
    return (
        <div className="form-group">
            <label htmlFor="competition_type" className="col-md-4 control-label">
                {label}{isRequired ? '*' : ''}
            </label>
            <div className="col-md-8">
                <Select name={name}
                        id={id || name}
                        multi={isMulti}
                        value={value}
                        options={options}
                        onChange={onChange}
                        placeholder={window.__js_general.choose_literal}/>
            </div>
        </div>
    );
}

export default DropdownFormGroup;